<script setup lang="ts">
import type { TabsIndicatorProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { TabsIndicator } from 'reka-ui'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<TabsIndicatorProps & { class?: HTMLAttributes['class'] }>()

const delegated = reactiveOmit(props, 'class')
</script>

<template>
  <TabsIndicator
    v-bind="delegated"
    :class="
      cn(
        'absolute -bottom-px h-1 bg-primary-300 transition-[left,width] duration-200 ease-out',
        'left-(--reka-tabs-indicator-position) w-(--reka-tabs-indicator-size)',
        props.class,
      )
    "
  />
</template>
